import { i18n } from '@/plugins/i18n'
import { LinkStatus } from '@/constants'
import { invertKeyValues } from '@/common/objects'

export const statusStr = (link) => {
    const status = invertKeyValues(LinkStatus)[link.status]

    return status ? i18n.t(`link.statuses.${status.toLowerCase()}`) : 'undefined'
}

export const statusColor = (link) => {
    const colors = {
        [LinkStatus.ACTIVE]: 'success',
        [LinkStatus.DISABLE]: 'warning',
        [LinkStatus.PENDING_TO_REDIRECT]: 'light',
        [LinkStatus.REDIRECTED]: 'secondary',
        [LinkStatus.PRODUCT_DELETED]: 'warning',
        [LinkStatus.PROMOTION_DELETED]: 'warning',
    }

    return colors[link.status]
}